// @flow
import { makeAPICall, APIError } from '../generalCreators';
import type { ThunkAction } from '../../types';

export const LOAD_GLOBAL_SETTINGS = 'LOAD_GLOBAL_SETTINGS';
export const LOAD_GLOBAL_SETTING = 'LOAD_GLOBAL_SETTING';

export type LoadGlobalSettingAction = {
  type: 'LOAD_GLOBAL_SETTING',
  setting: Object
};
export type LoadGlobalSettingsAction = {
  type: 'LOAD_GLOBAL_SETTINGS',
  settings: Object
};

export function getSettings(): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/globalsettings';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const settings = response.data.globalSettings;
        dispatch({ type: LOAD_GLOBAL_SETTINGS, settings });
      },
      error => dispatch(APIError(error, 'Error getting Global Settings'))
    );
  };
}

export function updateSetting(settings: Object[]): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/globalsettings`;
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      data: {
        globalSettings: settings
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getSettings());
        return response;
      },
      error => dispatch(APIError(error, 'Error updating Settings'))
    );
  };
}

export function getSetting(setting: string): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/globalsetting/${setting}`;
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const setting = response.data.globalSetting;
        return dispatch({ type: LOAD_GLOBAL_SETTING, setting });
      },
      error => dispatch(APIError(error, 'Error getting Setting'))
    );
  };
}

export function getPublicSetting(setting: string): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/globalsetting/nontoken/${setting}`;
    const options = {
      method: 'GET'
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const setting = response.data.globalSetting;
        return dispatch({ type: LOAD_GLOBAL_SETTING, setting });
      },
      error => dispatch(APIError(error, 'Error getting Setting'))
    );
  };
}

export function invalidateTC(): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/globalsetting/tcinvalidate';
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getSettings());
        return response;
      },
      error => dispatch(APIError(error, 'Error updating Settings'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/settings/basicCreators.js